import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'rxjs';
import { menuList } from '../../../utils/menulist';
import { LogoComponent } from '../../common/logo';

interface MenuItem {
  path?: string;
  title: string;
  iconClass: string;
  type: 'link' | 'sub';
  Menusub: boolean;
  module?: string[];
  active?: boolean;
  selected?: boolean;
  children?: MenuItem[];
  page?: string;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    RouterModule,
    CommonModule,
    LogoComponent,
    NgbPopoverModule,
    FormsModule,
    NgbTooltipModule,
    NgbDropdownModule,
  ],
})
export class SidebarComponent {
  public menuItems = menuList;
  private collapseSidebar: boolean = window.innerWidth < 1023;
  private openMenu: any = null;
  viewportRuler: any;
  @ViewChild('dropdownToggle', { static: false }) dropdownToggle: ElementRef | undefined;
  dataSpaceLists: any = [];
  searchContent: string = '';
  selectedDataSpace: any;
  showDataSpacePopup: boolean = false;
  isToggleClick: boolean = false;
  addSpace: boolean = false;
  isShowlisting: boolean = false;
  dropdownContainer = 'body';
  featurePermission: any;

  constructor(private readonly router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.sidebarClose();
    });
  }

  toggleSidebar(event: any) {
    this.isToggleClick = !this.isToggleClick;
    document.querySelector('body')?.classList.toggle('sidenav-toggled');
  }

  toggleMenu(menuItem: any): void {
    this.openMenu = this.openMenu === menuItem ? null : menuItem;
  }

  hideToggle() {
    this.openMenu = null;
  }

  isOpen(menuItem: any): boolean {
    return this.openMenu === menuItem;
  }

  sidebarClose() {
    if (this.collapseSidebar) {
      const bodyElement = document.querySelector('body');
      if (bodyElement?.classList.contains('sidenav-toggled')) {
        bodyElement.classList.remove('sidenav-toggled');
      }
      if (bodyElement?.classList.contains('sidenavToggledMobile')) {
        bodyElement.classList.remove('sidenavToggledMobile');
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.collapseSidebar = window.innerWidth < 1023;
    this.sidebarClose();
  }
}
